import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconDashComponent } from "./med-icon-dash.component";

@NgModule({
  declarations: [
    MedIconDashComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconDashComponent,
  ],
})
export class MedIconDashModule { }
